const PAGE_SIZES = [20, 50, 100]

function pageWindow(page, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1)
  }
  const pages = new Set([1, totalPages, page - 1, page, page + 1])
  if (page <= 3) {
    pages.add(2)
    pages.add(3)
    pages.add(4)
  }
  if (page >= totalPages - 2) {
    pages.add(totalPages - 3)
    pages.add(totalPages - 2)
    pages.add(totalPages - 1)
  }
  return [...pages].filter((value) => value >= 1 && value <= totalPages).sort((a, b) => a - b)
}

export default function Pagination({
  page,
  totalPages,
  total,
  limit,
  onPageChange,
  onLimitChange,
  disabled = false,
  itemLabel = '개 품목',
  limitLabel = '페이지당 품목 수',
}) {
  const pages = pageWindow(page, totalPages)

  return (
    <div className="pagination">
      <p className="pagination__summary">
        총 {total.toLocaleString('ko-KR')}
        {itemLabel} | {page} / {totalPages} 페이지
      </p>
      <div className="pagination__controls">
        <label className="pagination__limit">
          <span>페이지당</span>
          <select
            className="input"
            value={limit}
            disabled={disabled}
            onChange={(event) => onLimitChange(Number(event.target.value))}
            aria-label={limitLabel}
          >
            {PAGE_SIZES.map((size) => (
              <option key={size} value={size}>
                {size}개
              </option>
            ))}
          </select>
        </label>
        <div className="pagination__pages">
          <button
            type="button"
            className="btn btn--ghost btn--small"
            disabled={disabled || page <= 1}
            onClick={() => onPageChange(page - 1)}
          >
            이전
          </button>
          {pages.map((value, index) => {
            const prev = pages[index - 1]
            return (
              <span key={value} className="pagination__page-wrap">
                {prev && value - prev > 1 ? <span className="pagination__ellipsis">…</span> : null}
                <button
                  type="button"
                  className={`pagination__page ${value === page ? 'is-active' : ''}`}
                  disabled={disabled}
                  onClick={() => onPageChange(value)}
                >
                  {value}
                </button>
              </span>
            )
          })}
          <button
            type="button"
            className="btn btn--ghost btn--small"
            disabled={disabled || page >= totalPages}
            onClick={() => onPageChange(page + 1)}
          >
            다음
          </button>
        </div>
      </div>
    </div>
  )
}
